/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "context/AuthContext";
import { Outlet } from "react-router";
import { UserInfo } from "components/user-info";

import "./styles.scss";
import { NavMenu } from "components/navmenu";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useModal } from "context/ModalContext";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  IPrizes,
  getPrizes,
  getPremiosECards,
  purchaseItem,
} from "services/store.service";
import { getCardsRecebidos, getTeamStatus } from "services/achievement.service";
import { getTeamById } from "services/teams.service";
import { DetailCardsModal } from "./Components/modal-detail";
import { toast } from "react-toastify";
import { RegulamentoFooter } from "components/regulamento-footer";
import { RegulamentoLink } from "components/regulamento-link";
import { PurchaseItemModal } from "./Components/modal-purchase";
import { ConfirmResgateModal } from "./Components/modal-confirm-resgate";
import { VideoCardsModal } from "./Components/modal-video";

import IconCard from "assets/img/icon-card-sm.png";
import IconPlay from "assets/img/icon-play.png";
import noImage from "assets/img/semImagem.jpg";
import {
  CARDS_AUTOCONTIDOS_CATALOG_IDS,
  PREMIOS_ESPECIAIS_CATALOG_ID,
  RESGATE_PREMIO_ESPECIAL_ENCERRADO,
  PREMIOS_CATALOG_IDS,
} from "utils/constants";
import { getBanner, getAllBanners } from "services/premios.service";
import { IVideo, getLatestVideo } from "services/videos.service";
import { Carousel as ResponsiveCarousel } from "react-responsive-carousel";

// Moeda entregue por cada prêmio: como chamá-la e onde ela é usada.
const REWARD_CURRENCIES: Record<string, { label: string; destination: string }> =
  {
    star: {
      label: "estrelas",
      destination: "para trocar no <strong>Mercado de Estrelas</strong>.",
    },
    brb_points: {
      label: "pontos",
      destination: "para trocar no <strong>Mundo BRB</strong>.",
    },
    giro: {
      label: "giros",
      destination: "Para utilizar na <strong>Roleta</strong>.",
    },
  };

const DEFAULT_REWARD_LABEL = "pontos";

function getRewardCurrency(item: any) {
  return REWARD_CURRENCIES[item?.rewards?.[0]?.item];
}

function returnRewardLabel(item: any) {
  return getRewardCurrency(item)?.label ?? DEFAULT_REWARD_LABEL;
}

function returnTextReward(item: any) {
  if (!item?.rewards?.[0]?.item) {
    return "Recompensa não definida.";
  }

  return getRewardCurrency(item)?.destination ?? "";
}

/**
 * Nos catálogos auto-contidos o card já é o prêmio inteiro e nenhum item de
 * prêmio o exige. Apontar o requisito para o próprio item deixa a vitrine de
 * cards montar esse prêmio com a mesma regra usada pelos colecionáveis.
 */
function withSelfRequirement(item: any) {
  if (!CARDS_AUTOCONTIDOS_CATALOG_IDS.includes(item?.catalogId)) return item;

  return { ...item, requires: [{ item: item._id, total: 1, type: 2 }] };
}

/** Prêmios cuja coleção de cards é exibida ao empregado. */
function isPremioComCards(item: any) {
  return (
    PREMIOS_CATALOG_IDS.includes(item?.catalogId) ||
    CARDS_AUTOCONTIDOS_CATALOG_IDS.includes(item?.catalogId)
  );
}

/** Prêmio especial: ganha moldura de destaque e botão de resgate próprio. */
function isPremioEspecial(item: any) {
  return item?.catalogId === PREMIOS_ESPECIAIS_CATALOG_ID;
}

/** Comparador que traz os prêmios especiais para o início da listagem. */
function especiaisPrimeiro(a: any, b: any) {
  return Number(isPremioEspecial(b)) - Number(isPremioEspecial(a));
}

export function Premios() {
  const { user } = useAuth();
  const { showModal } = useModal();
  const [cards, setCards] = useState<any>();
  const [teamOwner, setTeamOwner] = useState<any>();
  const [teamStatus, setTeamStatus] = useState<any>();
  const [prizes, setPrizes] = useState<IPrizes[]>();
  const [prizesTeam, setPrizesTeam] = useState<IPrizes[]>();
  const [cardsRecebidos, setCardsRecebidos] = useState<{
    [key: string]: number;
  }>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [banner, setBanner] = useState<any>();
  const [bannersLoaded, setBannersLoaded] = useState<boolean>(false);
  const [video, setVideo] = useState<IVideo | null>(null);

  

async function loadBanners() {
  const data = await getAllBanners();
  setBanner(data);

  if (!data || data.length === 0) {
    setBannersLoaded(true);
    return;
  }

  await Promise.all(
    data.map(
      (item: any) =>
        new Promise<void>((resolve) => {
          const image = new Image();
          image.onload = () => resolve();
          image.onerror = () => resolve();
          image.src = item.image.original.url;
        })
    )
  );

  setBannersLoaded(true);
}

  const responsivePremios = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  async function loadTeamStatus() {
    const data = await getTeamStatus(user?.extra.unidade);
    if (data.length) {
      let localTeamStatus: { [key: string]: any } = {};
      data.forEach(function (o, i) {
        localTeamStatus[o._id] = o?.total;
      });
      setTeamStatus(localTeamStatus);
    }
    loadItems();
  }

  async function loadItems() {
    const data = await getPremiosECards();
    setCards(data.map(withSelfRequirement));
    setLoading(false);
  }

  async function loadTeam() {
    const data = await getTeamById(user?.extra.unidade);
    if (!data) return;
    setTeamOwner(data.owner);
  }

  async function loadPrizes() {
    const data = (await getPrizes(user ? user._id : '', user?.extra.unidade)) as IPrizes[];
    setPrizes(data.filter((e) => e.player === user?._id));
    setPrizesTeam(data.filter((e) => e.player === user?.extra.unidade));
  }

  async function loadCardsRecebidos() {
    const data = await getCardsRecebidos(user ? user._id : "");
    setCardsRecebidos(data);
  }

  async function loadVideo() {
    const data = await getLatestVideo();
    setVideo(data);
  }

  useEffect(() => {
    setLoading(true);
    if (user?._id) {
      loadTeam();
      loadTeamStatus();
      loadPrizes();
      loadCardsRecebidos();
      loadBanners();
      loadVideo();
    }
  }, [user]);

  function getItem(id: string) {
    let obj = { image: { medium: { url: "" } } };
    cards?.forEach(function (o: any) {
      if (o._id === id) {
        obj = o;
      }
    });
    return obj;
  }

  function isRequirementUnlocked(o: any) {
    let ok = false;
    if (
      o.type === 0 &&
      user?.point_categories[o.item] &&
      user?.point_categories[o.item] >= o?.total
    ) {
      ok = true;
    } else if (
      o.type === 1 &&
      user?.challenges[o.item] &&
      user?.challenges[o.item] >= o?.total
    ) {
      ok = true;
    } else if (
      o.type === 2 &&
      user?.catalog_items[o.item] &&
      user?.catalog_items[o.item] >= o?.total
    ) {
      ok = true;
    } else if (o.type >= 3) {
      //ignorar qualquer outro tipo como level, crowning etc.
      ok = true;
    }
    return ok;
  }

  function isTeamRequirementUnlocked(o: any) {
    var ok = false;
    if (o.type === 0 && teamStatus[o.item] && teamStatus[o.item] >= o?.total) {
      ok = true;
    } else if (
      o.type === 1 &&
      teamStatus[o.item] &&
      teamStatus[o.item] >= o?.total
    ) {
      ok = true;
    } else if (
      o.type === 2 &&
      teamStatus[o.item] &&
      teamStatus[o.item] >= o?.total
    ) {
      ok = true;
    } else if (o.type >= 3) {
      //ignorar qualquer outro tipo como level, crowning etc.
      ok = true;
    }
    return ok;
  }

  function totRequirement(item: any) {
    let ok = 0;
    if (item && item.requires) {
      item.requires.forEach(function (o: any) {
        if (o.type === 0 && user?.point_categories[o.item]) {
          ok = ok + user?.point_categories[o.item];
        } else if (o.type === 1 && user?.challenges[o.item]) {
          ok = ok + user?.challenges[o.item];
        } else if (o.type === 2 && user?.catalog_items[o.item]) {
          ok = ok + user?.catalog_items[o.item];
        }
      });
    }
    return ok;
  }

  /** Card que o empregado já teve mas não possui mais: usado na troca do prêmio. */
  function isRequirementUsed(o: any) {
    return !!cardsRecebidos[o.item] && !isRequirementUnlocked(o);
  }

  /** Total de cards do prêmio que o empregado já recebeu, usados ou não. */
  function totRequirementRecebido(item: any) {
    let ok = 0;
    if (item && item.requires) {
      item.requires.forEach(function (o: any) {
        if (o.type === 2 && cardsRecebidos[o.item]) {
          ok = ok + cardsRecebidos[o.item];
        }
      });
    }
    return ok;
  }

  function totTeamRequirement(item: any) {
    var ok = 0;
    if (item && item.requires) {
      item.requires.forEach(function (o: any) {
        if (o.type === 0 && teamStatus && teamStatus[o.item]) {
          ok = ok + teamStatus[o.item];
        } else if (o.type === 1 && teamStatus && teamStatus[o.item]) {
          ok = ok + teamStatus[o.item];
        } else if (o.type === 2 && teamStatus && teamStatus[o.item]) {
          ok = ok + teamStatus[o.item];
        }
      });
    }
    return ok;
  }

  function totRequirementOk(item: any) {
    let ok = 0;
    if (item && item.requires) {
      item.requires.forEach(function (o: any) {
        if (
          o.type === 0 &&
          user?.point_categories[o.item] &&
          user?.point_categories[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (
          o.type === 1 &&
          user?.challenges[o.item] &&
          user?.challenges[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (
          o.type === 2 &&
          user?.catalog_items[o.item] &&
          user?.catalog_items[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (o.type >= 3) {
          //ignorar qualquer outro tipo como level, crowning etc.
          ok = ok + 1;
        }
      });
    }
    return ok;
  }

  function totTeamRequirementOk(item: any) {
    var ok = 0;
    if (item && item.requires) {
      item.requires.forEach(function (o: any) {
        if (
          o.type === 0 &&
          teamStatus[o.item] &&
          teamStatus[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (
          o.type === 1 &&
          teamStatus[o.item] &&
          teamStatus[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (
          o.type === 2 &&
          teamStatus[o.item] &&
          teamStatus[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (o.type >= 3) {
          //ignorar qualquer outro tipo como level, crowning etc.
          ok = ok + 1;
        }
      });
    }
    return ok;
  }

  /** Cards já recebidos pelo empregado, com os especiais à frente dos demais. */
  function getMeusCards() {
    return (cards ?? [])
      .filter(
        (item: any) => isPremioComCards(item) && totRequirementRecebido(item) > 0
      )
      .sort(especiaisPrimeiro);
  }

  /**
   * O card especial fica de fora do resgate automático: o empregado guarda o
   * card brilhando na vitrine e escolhe a hora de trocá-lo pela recompensa.
   */
  function podeResgatarPremioEspecial(item: any) {
    return isPremioEspecial(item) && totRequirement(item) > 0;
  }

  /** Com o prazo de troca encerrado, o botão só explica por que não resgata. */
  function avisarResgateEspecialEncerrado() {
    toast.info("O período de resgate do card especial já foi finalizado.", {
      position: "top-center",
      autoClose: 5000,
    });
  }

  /**
   * O resgate consome o card, então confirma antes: uma vez trocado, o card
   * some da vitrine e não há como voltar atrás.
   */
  function confirmarResgateEspecial(item: any) {
    const reward = item?.rewards?.[0];

    showModal("modal-confirm-resgate", {
      item,
      recompensa: reward
        ? `${reward.total} ${returnRewardLabel(item)}`
        : undefined,
      onConfirm: () => purchase(item, "funcionario"),
    });
  }

  /** Estado do quadro do card: destaque do especial e apagado do já utilizado. */
  function getCardClassName(item: any) {
    return [
      "item",
      isPremioEspecial(item) && "itemEspecial",
      totRequirement(item) <= 0 && "itemUsado",
    ]
      .filter(Boolean)
      .join(" ");
  }

  function hasCardColecionavelUnidade() {
    var has = false;
    cards?.forEach(function (o: any) {
      if (PREMIOS_CATALOG_IDS.includes(o.catalogId) && totTeamRequirement(o) > 0) {
        has = true;
      }
    });
    return has;
  }

  function showPremioCards(item: any, type: string) {
    let cards: any[] = [];

    if (item && item.requires && isPremioComCards(item)) {
      item.requires.forEach(function (o: any) {
        let card = {
          imgPremio: "",
          my: null,
          used: false,
          imgCard: { image: { medium: { url: "" } } },
          type: "",
        };
        card.imgPremio = item.image ? item.image.medium.url : noImage;
        card.imgCard = getItem(o.item);
        card.my =
          type === "funcionario"
            ? user?.catalog_items[o.item]
            : teamStatus[o.item];
        card.used = type === "funcionario" && !card.my && isRequirementUsed(o);
        card.type = type;
        cards.push(card);
      });
    }
    showModal("modal-detail-cards", { config: cards });
  }

  function purchase(item: any, type: string) {
    if (!!user?._id) {
      const idPurchase = type === "unidade" ? user.extra.unidade : user._id;

      purchaseItem(item._id, idPurchase).then(function (data) {
        if (data.status === "OK") {
          showModal("modal-purchase-item", item);

          //refreshUser();
        } else if (data.status === "UNAUTHORIZED") {
          toast(`❌ Ocorreu um erro, tente novamente mais tarde.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast(`❌ Ocorreu um erro, tente novamente mais tarde.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
    }
  }

  function hasUnlockedPremio() {
    var has = false;
    cards?.forEach(function (o: any) {
      if (PREMIOS_CATALOG_IDS.includes(o.catalogId) && isItemLocked(o) === false) {
        has = true;
      }
    });
    return has;
  }

  function hasTeamUnlockedPremio() {
    var has = false;
    cards?.forEach(function (o: any) {
      if (PREMIOS_CATALOG_IDS.includes(o.catalogId) && isTeamItemLocked(o) === false) {
        has = true;
      }
    });
    return has;
  }

  function isItemLocked(item: any) {
    var ok = 0;
    if (item && item.requires) {
      item.requires.forEach(function (o: any) {
        if (
          o.type === 0 &&
          user?.point_categories[o.item] &&
          user?.point_categories[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (
          o.type === 1 &&
          user?.challenges[o.item] &&
          user?.challenges[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (
          o.type === 2 &&
          user?.catalog_items[o.item] &&
          user?.catalog_items[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (o.type >= 3) {
          //ignorar qualquer outro tipo como level, crowning etc.
          ok = ok + 1;
        }
      });
    }
    return !(ok === item.requires.length);
  }

  function isTeamItemLocked(item: any) {
    var ok = 0;
    if (item && item.requires) {
      item.requires.forEach(function (o: any) {
        if (
          o.type === 0 &&
          teamStatus &&
          teamStatus[o.item] &&
          teamStatus[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (
          o.type === 1 &&
          teamStatus &&
          teamStatus[o.item] &&
          teamStatus[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (
          o.type === 2 &&
          teamStatus &&
          teamStatus[o.item] &&
          teamStatus[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (o.type >= 3) {
          //ignorar qualquer outro tipo como level, crowning etc.
          ok = ok + 1;
        }
      });
    }
    return !(ok === item.requires.length);
  }

  function isTeamManager() {
    return user?._id === teamOwner;
  }

  if (!user) return null;

  const meusCards = getMeusCards();

  return (
    <>
      <Helmet>
        <title>CONTA COMIGO BRB</title>
      </Helmet>
      <div id="home-wrapper" className="min-h-screen">
        <div
          className="z-10 relative flex flex-col items-center space-y-0"
          id="pagePremios"
        >
          <NavMenu />

          <div className="w-full flex justify-center md:p-0">
            <UserInfo />
          </div>
          <div className="bg-[#0938A3] w-screen text-white md:-mx-10 bgShadow">
            {/* <div className="w-full md:w-[1200px] mx-auto  p-5 md:p-8 meusPremios">
              <h2>
                Confira seus <strong>prêmios</strong>
              </h2>

              {loading && (
                <p className="text-center noCards">Carregando...</p>
              )}

              {!loading && !hasUnlockedPremio() && prizes?.length === 0 && (
                <p className="text-center noCards">
                  Você não possui prêmios para trocar por pontos no{" "}
                  <strong>mundo BRB</strong>
                </p>
              )}

              <div className="">
                {cards && (
                  <Carousel
                    responsive={responsivePremios}
                    className="contentCards"
                  >
                    {cards
                      ?.filter((e: any) => {
                        if (
                          PREMIOS_CATALOG_IDS.includes(e.catalogId) &&
                          totRequirement(e) >= 1 &&
                          !isItemLocked(e)
                        ) {
                          return e;
                        }
                        return false;
                      })
                      .map((item: any, i: number) => (
                        <span className="containerCard" key={i}>
                          <div className="item">
                            <img
                              src={item.image ? item.image.medium.url : noImage}
                              alt=""
                              title={item.name}
                            />
                            <h3>
                              <strong>Parabéns</strong>
                            </h3>
                            <div>
                              {item.rewards && item.rewards[0] ? (
                                <p>
                                  Você acabou de ganhar <br />
                                  <strong>
                                    {item.rewards[0]?.total}{" "}
                                    {returnRewardLabel(item)}
                                  </strong>{" "}
                                  <div
                                    dangerouslySetInnerHTML={{ __html: returnTextReward(item) }}
                                  ></div>
                                </p>
                              ) : (
                                <p>
                                  Você acabou de ganhar <br />
                                  <strong>{item.name}</strong>
                                </p>
                              )}
                            </div>
                          </div>
                          {item.rewards && item.rewards[0] ? (
                            <button
                              onClick={() => {
                                purchase(item, "funcionario");
                              }}
                            >
                              RECEBER {returnRewardLabel(item).toUpperCase()}
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                purchase(item, "funcionario");
                              }}
                            >
                              RECEBER
                            </button>
                          )}
                        </span>
                      ))}
                    {prizes?.map((prize) => (
                      <span className="containerCard" key={prize._id}>
                        <div className="item">
                          <img src={prize.image} alt="" title={prize.name} />

                          <h3>
                            <strong>Parabéns</strong>
                          </h3>
                          <div>
                            <p>
                              Você ganhou <br />
                              <strong>{prize.name}</strong>
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            showModal("modal-purchase-item", prize);
                          }}
                        >
                          INFORMAÇÕES
                        </button>
                      </span>
                    ))}
                  </Carousel>
                )}
              </div>
            </div> */}

            {/* <div className="w-full md:w-[1200px] mx-auto  p-5 md:p-8 meusPremios">
              <h2>
                Prêmios da <strong>unidade</strong>
              </h2>

              {!hasTeamUnlockedPremio() && prizesTeam?.length === 0 && (
                <p className="text-center noCards">
                  A unidade não possui prêmios para trocar por pontos no{" "}
                  <strong>mundo BRB</strong>
                </p>
              )}

              <div className="">
                {cards && (
                  <Carousel
                    responsive={responsivePremios}
                    className="contentCards"
                  >
                    {cards
                      ?.filter((item: any) => {
                        if (
                          PREMIOS_CATALOG_IDS.includes(item.catalogId) &&
                          totTeamRequirement(item) >= 1 &&
                          !isTeamItemLocked(item)
                        ) {
                          return item;
                        }
                        return false;
                      })
                      .map((item: any, i: number) => (
                        <span className="containerCard" key={i}>
                          <div className="item">
                            <img
                              src={item.image ? item.image.medium.url : noImage}
                              alt=""
                              title={item.name}
                            />
                            <h3>
                              <strong>Parabéns</strong>
                            </h3>
                            <div>
                              {item.rewards && item.rewards[0] ? (
                                <p>
                                  Sua unidade acabou de ganhar <br />
                                  <strong>
                                    {item.rewards[0]?.total} pontos
                                  </strong>{" "}
                                  <div
                                    dangerouslySetInnerHTML={{ __html: returnTextReward(item) }}
                                  ></div>
                                </p>
                              ) : (
                                <p>
                                  Sua unidade acabou de ganhar <br />
                                  <strong>{item.name}</strong>
                                </p>
                              )}
                            </div>
                          </div>
                          {!isTeamItemLocked(item) && !isTeamManager() && (
                            <button>
                              Avise o responsável pela unidade para regatar
                            </button>
                          )}
                          {!isTeamItemLocked(item) && isTeamManager() && (
                            <>
                              {item.rewards && item.rewards[0] ? (
                                <button
                                  onClick={() => {
                                    purchase(item, "unidade");
                                  }}
                                >
                                  RECEBER PONTOS
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    purchase(item, "unidade");
                                  }}
                                >
                                  RECEBER
                                </button>
                              )}
                            </>
                          )}
                        </span>
                      ))}
                    {prizesTeam?.map((prize) => (
                      <span className="containerCard" key={prize._id}>
                        <div className="item">
                          <img src={prize.image} alt="" title={prize.name} />
                          <h3>
                            <strong>Parabéns</strong>
                          </h3>

                          <div>
                            {" "}
                            <p>
                              Sua unidade ganhou <br />
                              <strong>{prize.name}</strong>
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            showModal("modal-purchase-item", {
                              ...prize,
                              type: "unidade",
                              isOwner: isTeamManager(),
                            });
                          }}
                        >
                          INFORMAÇÕES
                        </button>
                      </span>
                    ))}
                  </Carousel>
                )}
              </div>
            </div> */}
          </div>

          {banner && banner.length > 0 && banner[0].isActive  && (
            <section className="w-full  bg-[#FFFFFF]">
              <div className="md:mx-auto max-w-[900px] z-10 relative carouselMobile">
                <ResponsiveCarousel
                  showArrows={true}
                  showThumbs={false}
                  infiniteLoop={true}
                  autoPlay={true}
                  interval={10000}
                >
                  {banner.map((item: any, i: number) => (
                    <div key={i}>
                      {item.link ? (
                        <a className="block" href={item.link} target="_blank" rel="noopener noreferrer">
                          <img src={item.image.original.url} alt={item.title} />
                        </a>
                      ) : (
                        <img src={item.image.original.url} alt={item.title} />
                      )}
                    </div>
                  ))}
                </ResponsiveCarousel>
              </div>
            </section>
          )}

          <div className=" w-screen text-white md:-mx-10 ">
            <div className="w-full md:w-[1200px] mx-auto p-5 md:p-8 meusCards">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <h2>
                  Meus <strong>cards</strong>
                </h2>
                <RegulamentoLink
                  type="cards"
                  label="Confira o regulamento dos cards aqui"
                  className="mr-[35px]"
                />
              </div>

              {video && (
                <button
                  type="button"
                  className="videoCards"
                  onClick={() => showModal("modal-video-cards", video)}
                >
                  <img src={IconPlay} alt="" className="play" />
                  <span className="info">
                    <span className="eyebrow">Vídeo</span>
                    <span className="name">{video.title}</span>
                  </span>
                  <span className="cta">ASSISTIR</span>
                </button>
              )}

              <div className="">
                {loading && (
                  <p className="text-center noCards">Carregando...</p>
                )}
                {!loading && meusCards.length === 0 && (
                  <p className="text-center noCards">Você não possui cards</p>
                )}
                {meusCards.length > 0 && (
                  <Carousel
                    responsive={responsivePremios}
                    className="contentCards"
                  >
                    {meusCards.map((item: any, i: number) => (
                      <span key={i}>
                        <div className={getCardClassName(item)}>
                          {isPremioEspecial(item) && (
                            <span className="selo">Especial</span>
                          )}
                          <p className="title" title={item.name}>
                            {item.name}
                          </p>
                          <p
                            className="totalItems"
                            title={`Você possui ${totRequirement(item)} de ${
                              item.requires.length
                            } parte${
                              item.requires.length > 1 ? "s" : ""
                            } deste prêmio`}
                          >
                            <span className="first">
                              {totRequirementOk(item)}
                            </span>{" "}
                            <span className="middle">/</span>{" "}
                            <span className="last">{item.requires.length}</span>
                          </p>
                          <img
                            src={item.image ? item.image.medium.url : noImage}
                            alt=""
                            className="bgItem"
                          />
                          {item.requires.map((obj: any, i: number) => (
                            <span key={i} title={item.name}>
                              {(isRequirementUnlocked(obj) ||
                                isRequirementUsed(obj)) && (
                                <img
                                  src={getItem(obj.item).image.medium.url}
                                  alt=""
                                  className={
                                    isRequirementUsed(obj) ? "cardUsado" : ""
                                  }
                                />
                              )}
                            </span>
                          ))}
                          <div>
                            <p>
                              <img src={IconCard} alt="" />
                              {totRequirement(item) > 0 ? (
                                <>
                                  Você possui {totRequirement(item)} card
                                  {totRequirement(item) > 1 ? "s" : ""}
                                </>
                              ) : (
                                <>Card já utilizado</>
                              )}
                            </p>
                            <p>
                              {podeResgatarPremioEspecial(item) &&
                              RESGATE_PREMIO_ESPECIAL_ENCERRADO ? (
                                <button
                                  className="btnResgatar btnEncerrado"
                                  onClick={avisarResgateEspecialEncerrado}
                                >
                                  ENCERRADO
                                </button>
                              ) : podeResgatarPremioEspecial(item) ? (
                                <button
                                  className="btnResgatar"
                                  onClick={() => {
                                    confirmarResgateEspecial(item);
                                  }}
                                >
                                  RESGATAR -&gt;
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    showPremioCards(item, "funcionario");
                                  }}
                                >
                                  VER -&gt;
                                </button>
                              )}
                            </p>
                          </div>
                        </div>
                      </span>
                    ))}
                  </Carousel>
                )}
              </div>
            </div>
            {/* <div className="w-full md:w-[1200px] mx-auto p-5 md:p-8 meusCards">
              <h2>
                Cards da <strong>unidade</strong>
              </h2>

              <div className="">
                {!hasCardColecionavelUnidade() && (
                  <p className="text-center noCards">
                    Sua unidade não possui cards
                  </p>
                )}
                {cards && hasCardColecionavelUnidade() && (
                  <Carousel
                    responsive={responsivePremios}
                    className="contentCards"
                  >
                    {cards
                      ?.filter((e: any) => {
                        if (
                          PREMIOS_CATALOG_IDS.includes(e.catalogId) &&
                          totTeamRequirement(e) >= 1
                        ) {
                          return e;
                        }
                        return false;
                      })
                      .map((item: any, i: number) => (
                        <span key={i}>
                          <div className="item" title={item.name}>
                            <p className="title">{item.name}</p>
                            <p className="totalItems">
                              <span className="first">
                                {totTeamRequirementOk(item)}
                              </span>{" "}
                              <span className="middle">/</span>{" "}
                              <span className="last">
                                {item.requires.length}
                              </span>
                            </p>
                            <img
                              src={item.image ? item.image.medium.url : noImage}
                              alt=""
                              className="bgItem"
                            />
                            {item.requires.map((obj: any, i: number) => (
                              <span key={i}>
                                {isTeamRequirementUnlocked(obj) && (
                                  <img
                                    src={getItem(obj.item).image.medium.url}
                                    alt=""
                                  />
                                )}
                              </span>
                            ))}
                            <div>
                              <p>
                                <img src={IconCard} alt="" />
                                Sua unidade possui {totTeamRequirement(
                                  item
                                )}{" "}
                                card
                                {totTeamRequirement(item) > 1 ? "s" : ""}
                              </p>
                              <p>
                                <button
                                  onClick={() => {
                                    showPremioCards(item, "unidade");
                                  }}
                                >
                                  {" "}
                                  VER -&gt;
                                </button>
                              </p>
                            </div>
                          </div>
                        </span>
                      ))}
                  </Carousel>
                )}
              </div>
            </div> */}
          </div>
        </div>
        <RegulamentoFooter />
      </div>
      <Outlet />
      <DetailCardsModal />
      <PurchaseItemModal />
      <ConfirmResgateModal />
      <VideoCardsModal />
    </>
  );
}